import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import ConfigETC from "../Class/ConfigETC.json";
import {
  Bind_Select_Status,
  Bind_Presets_Calendar,
  formatDate,
  datagridtoolbarOptions,
  pdfExportProperties_Reportsummary_Pos_Tran,
  excelExportProperties_Reportsummary_Pos_Tran,
  csvExportProperties_Reportsummary_Pos_Tran,
  ConvertMiniutDuration_calbyconfig,
  Returnhidevalue,
  HtmlTooltip,
  Class_ETC_SessionTimeOut,
  date_pickerStyle
} from "../Class/Class_Etc";
import { DateRangePickerComponent } from "@syncfusion/ej2-react-calendars";
import Select from "react-select";
import makeAnimated from "react-select/animated";

import SelectTaskMultiGroup from "../Library/Select_TaskMultiGroup";
import SelectStaff from "../Library/Select_Staff";
import SelectTimeoff from "../Library/Select_Timeoff";
import SelectCustomer from "../Library/Select_Customer";

import {
  GridComponent,
  ColumnsDirective,
  ColumnDirective,
  Page,
  Sort,
  Inject,
  Toolbar,
  PdfExport,
  ExcelExport,
  Group,
  Resize,
  Reorder,
} from "@syncfusion/ej2-react-grids"; //synfusion data grid

import { updateSampleSection } from "../Main/Sample-base"; //synfusion data grid
import { CP_CheckPermission } from "../Class/Class_Permission";
import { customStylesSelect } from "../Class/Class_Etc"

import SelectProjectByCustomerBySearch from "../Library/Select_ProjectByCustomer";

/*  Create By POOM : 28/09/2023 
    Edit  By  POOM : 07/09/2023 เพิ่ม กดปุ่ม enter คีย์บอร์ด แล้วค้นหาได้เหมือนกดปุ่ม search 
    Update By Krisana : 09-05-2024 - แก้ไขโดยเพิ่มเงื่อนไขการค้นหาด้วย Customer 
    Update By Krisana : 13-05-2024 - แก้ไข DDL Project ให้ Filter ตาม cus_id 
    
    Update By POOM : 14-05-2024 : 
      - เพิ่ม service ot เข้ามา เพราะฉนั้น ถ้าไม่มี service ot จะปิดทุกอย่างที่เกี่ยวกับ OT ออกเลย ไม่ให้บันทึกไม่ให้เห็นข้อมูล
*/

function Report_sumByTransaction() {
  //#region __ Declare __

  const isSVOT = CP_CheckPermission("service_list" , ["ot"],false,false);
  const [isFirst, setIsFirst] = useState(true);
  const [isLoadProgress, setIsLoadProgress] = useState(true);
  const [isLoadedConfigData, setIsLoadedConfigData] = useState(false);
  const [configData, setConfigData] = useState([]);
  const [isSearch, setIsSearch] = useState(false);
  const [listReport, setListReport] = useState([]);

  const animatedComponents = makeAnimated();
  const [selectedSearchCustomer, setSelectedSearchCustomer] = useState(null);
  const [selectedSearchProjeact, setSelectedSearchProjeact] = useState([]);
  const [selectedSearchstaff, setSelectedSearchStaff] = useState([]);
  const [selectedSearchTask, setSelectedSearchTask] = useState([]);
  const [selectedSearchTimeoff, setSelectedSearchTimeoff] = useState([]);
  const [selectedSearchStatus, setSelectedSearchStatus] = useState([]);
  const [iscntreset, setIscntreset] = useState(0);

  const dataPresets = Bind_Presets_Calendar();

  const [exportSearchCustomer, setExportSearchCustomer] = useState("");
  const [exportSearchProjeact, setExportSearchProjeact] = useState("");
  const [exportSearchstaff, setExportSearchStaff] = useState("");
  const [exportSearchTask, setExportSearchTask] = useState("");
  const [exportSearchTimeoff, setExportSearchTimeoff] = useState("");
  const [exportSearchdate, setExportSearchdate] = useState("");
  const [exportSearchStatus, setExportSearchStatus] = useState("");

  const [bindProjectBycusid, setBindProjectBycusid] = useState(0);

  //#endregion

  //#region __ UseEffect __

  useEffect(() => {
    if (isFirst === true) {
      let ckpermission = CP_CheckPermission("report", ["report_transaction_view"], false , true);
      if (ckpermission)
      {
        GetConfig();
        if (isLoadedConfigData === true) {
          updateSampleSection();
          setIsFirst(false);
          setIsLoadProgress(false);
        }
      }
    }
    //eslint-disable-next-line
  }, [isLoadedConfigData]);

  useEffect(() => {
    window.addEventListener('keydown', handleKeyDown);
    // Clean up the event listener when the component unmounts
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      document.getElementById("btn_Search").click();
    }
  };


  //#endregion

  //#region __ Function __

  async function GetConfig() {
    await fetch("../ConfigData.json")
      .then((res) => res.json())
      .then((data) => {
        setConfigData(data);
        setIsLoadedConfigData(true);
      })
      .catch((err) => err);
  }

  function Bindendfunction_SP(){
    setIsLoadProgress(false)
  }

  async function BindList(
    cus_id,
    Project_id,
    task_id,
    timeoff_id,
    staff_id,
    date_start,
    date_end,
    status,
    _callback
  ) {
    try {
      let token = "";
      token = localStorage.getItem("TStoken");
      var myHeaders = new Headers();
      myHeaders.append("Authorization", "Bearer " + token);
      myHeaders.append("Content-Type", "application/json");

      var raw = JSON.stringify({
        cus_id_str: cus_id,
        pro_id_str: Project_id,
        task_id_str: task_id,
        time_off_str: timeoff_id,
        staff_id_str: staff_id,
        date_start_str: date_start,
        date_end_str: date_end,
        status_str: status,
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const response = await fetch(
        configData.API_URL + "Report_GetsumByTransaction",
        requestOptions
      );

      const json = await response.json();
      if (json.status_ID === 1) {
        if (json.total_Data > 0) {
          setListReport(json.data);
          if (_callback != null) {
            _callback();
          }
        } else {
          setListReport([]);
          if (_callback != null) {
            _callback();
          }
        }
      }
      else if (json.status_ID === 2) 
      {
        Class_ETC_SessionTimeOut();
      }
      else
      {
        setListReport([]);
        if (_callback != null) {
          _callback();
        }
      }
    } catch {
      setListReport([]);
      if (_callback != null) {
        _callback();
      }
    }
  }

  //#endregion

  //#region __ Event __

  function onChangevaluesCustomer(e) {
    setSelectedSearchCustomer(e)
      if (e === null)
      {
        document.getElementById("hd_cus_id_search").value = "-1";
      }
      else
      {
        document.getElementById("hd_cus_id_search").value = e.value;
      }
      setBindProjectBycusid((bindProjectBycusid) => bindProjectBycusid + 1);
      setIsLoadProgress(true);
  }

  function onChangevaluesProject(e) {
    setSelectedSearchProjeact(e);
  }

  function onChangevaluesTimeoff(e) {
    setSelectedSearchTimeoff(e);
  }

  function onChangevaluesTask(e) {
    setSelectedSearchTask(e);
  }

  function onChangevaluesStaff(e) {
    setSelectedSearchStaff(e);
  }

  function onclickReset() {
    setIscntreset((iscntreset) => iscntreset + 1);
    setSelectedSearchStatus(null);
    document.getElementById("txt_SearchDate").value = "";
    setIsSearch(false);
  }

  function onclickSearch() {
    let ValueCustomer = "";
    let ValueCustomertext = "";
    let ValueProject = "";
    let ValueProjecttext = "";
    let ValueTask = "";
    let ValueTasktext = "";
    let ValueStaff = "";
    let ValueStaffText = "";
    let ValueTimeoff = "";
    let ValueTimeofftext = "";
    let ValueDateS = "";
    let ValueDateE = "";
    let ValueStatus = "";
    let ValueStatustext = "";

    if (selectedSearchCustomer !== null) {
      if (selectedSearchCustomer.value !== -1){
        ValueCustomer = selectedSearchCustomer.value.toString();
        ValueCustomertext = selectedSearchCustomer.label;
      }
      else{
        ValueCustomer = ""
        ValueCustomertext = ConfigETC.ddl_All
      }
    }

    if (selectedSearchProjeact !== null) {
      if (selectedSearchProjeact.length > 0) {
        for (let i = 0; i < selectedSearchProjeact.length; i++) {
          ValueProject =
            ValueProject +
            (ValueProject === "" ? "" : ",") +
            selectedSearchProjeact[i].value;
          ValueProjecttext =
            ValueProjecttext +
            (ValueProjecttext === "" ? "" : ",") +
            selectedSearchProjeact[i].label;
        }
      }
    }

    if (selectedSearchTask !== null) {
      if (selectedSearchTask.length > 0) {
        for (let i = 0; i < selectedSearchTask.length; i++) {
          ValueTask =
            ValueTask +
            (ValueTask === "" ? "" : ",") +
            selectedSearchTask[i].value;
          ValueTasktext =
            ValueTasktext +
            (ValueTasktext === "" ? "" : ",") +
            selectedSearchTask[i].label;
        }
      }
    }

    if (selectedSearchTimeoff !== null) {
      if (selectedSearchTimeoff.length > 0) {
        for (let i = 0; i < selectedSearchTimeoff.length; i++) {
          ValueTimeoff =
            ValueTimeoff +
            (ValueTimeoff === "" ? "" : ",") +
            selectedSearchTimeoff[i].value;
          ValueTimeofftext =
            ValueTimeofftext +
            (ValueTimeofftext === "" ? "" : ",") +
            selectedSearchTimeoff[i].label;
        }
      }
    }

    if (selectedSearchstaff !== null) {
      if (selectedSearchstaff.length > 0) {
        for (let i = 0; i < selectedSearchstaff.length; i++) {
          ValueStaff =
            ValueStaff +
            (ValueStaff === "" ? "" : ",") +
            selectedSearchstaff[i].value;
          ValueStaffText =
            ValueStaffText +
            (ValueStaffText === "" ? "" : ",") +
            selectedSearchstaff[i].label;
        }
      }
    }

    if (selectedSearchStatus !== null) {
      if (selectedSearchStatus.length > 0) {
        for (let i = 0; i < selectedSearchStatus.length; i++) {
          ValueStatus =
            ValueStatus +
            (ValueStatus === "" ? "" : ",") +
            selectedSearchStatus[i].value;
          ValueStatustext =
            ValueStatustext +
            (ValueStatustext === "" ? "" : ",") +
            selectedSearchStatus[i].label;
        }
      }
    }

    let date_rang = document.getElementById("txt_SearchDate").value;
    if (date_rang !== "") {
      let datevalue = date_rang.split(" - ");
      if (datevalue.length === 2) {
        ValueDateS = datevalue[0];
        ValueDateE = datevalue[1];
      }
    }

    setExportSearchCustomer(ValueCustomertext);
    setExportSearchProjeact(ValueProjecttext);
    setExportSearchdate(
      ValueDateS +
        (ValueDateS !== "" && ValueDateE !== "" ? " - " : "") +
        ValueDateE
    );
    setExportSearchTask(ValueTasktext);
    setExportSearchStaff(ValueStaffText);
    setExportSearchTimeoff(ValueTimeofftext);
    setExportSearchStatus(ValueStatustext);
    setIsLoadProgress(true);
    BindList(
      ValueCustomer,
      ValueProject,
      ValueTask,
      ValueTimeoff,
      ValueStaff,
      ValueDateS,
      ValueDateE,
      ValueStatus,
      function () {
        setIsSearch(true);
        setIsLoadProgress(false);
      }
    );
  }

  //#endregion

  //#region __ Grid __

  let gridInstance;
  let gridInstancePrint;
  function beforePrint(args) {
    let theadEle = gridInstance.element
      .querySelector(".e-gridheader .e-headercontent thead")
      .cloneNode(true);
    let arrOfMOM = theadEle.children;
    args.element
      .querySelector(".e-gridheader .e-headercontent thead")
      .replaceChildren(...[].slice.call(arrOfMOM));
  }

  function toolbarClick(args) {
    const Customer = exportSearchCustomer;
    const Project = exportSearchProjeact;
    const Task = exportSearchTask;
    const Staffs = exportSearchstaff;
    const Timeoff = exportSearchTimeoff;
    const Daterang = exportSearchdate;
    const Status = exportSearchStatus;
    const DateExport = new Date();
    const _DateExport = formatDate(
      DateExport,
      "short en",
      "en",
      "",
      "datetimeexport"
    );
    const DateExport_ = formatDate(
      DateExport,
      "short en",
      "en",
      "/",
      "datetime"
    );
    let PDFname = "RP_sumbytransaction_" + _DateExport + ".pdf";
    let Excelname = "RP_sumbytransaction_" + _DateExport + ".xlsx";
    let Csvname = "RP_sumbytransaction_" + _DateExport + ".csv";
    let Report1 = "Report 5";
    let Report2 = "Timesheet summary by Transaction";

    let isckot = (isSVOT === true ? 0 : 2);
    
    if (gridInstance && args.item.id === "ExcelExport") {
      gridInstance.excelExport(
        excelExportProperties_Reportsummary_Pos_Tran(
          Excelname,
          Report1,
          Report2,
          Customer,
          Project,
          Task,
          Timeoff,
          Staffs,
          Daterang,
          Status,
          14 - isckot,
          DateExport_
        )
      );
    }
    
    if (gridInstance && args.item.id === "PdfExport") {
      gridInstance.pdfExport(
        pdfExportProperties_Reportsummary_Pos_Tran(
          PDFname,
          Report1,
          Report2,
          Customer,
          Project,
          Task,
          Timeoff,
          Staffs,
          Daterang,
          Status,
          DateExport_
        )
      );
    }
    
    if (gridInstance && args.item.id === "CsvExport") {
      gridInstance.csvExport(
        csvExportProperties_Reportsummary_Pos_Tran(
          Csvname,
          Report1,
          Report2,
          Customer,
          Project,
          Task,
          Timeoff,
          Staffs,
          Daterang,
          Status,
          14 - isckot,
          DateExport_
        )
      );
    }
    
    if (gridInstance && args.item.id === "Print") {
      gridInstancePrint.print();
    }
  }


  function faclockTemplate(props) {
    return (
      <div>
        <span className="far fa-clock text-muted"></span>
        &nbsp; {props.headerText}
      </div>
    );
  }

  function falightTemplate(props) {
    return (
      <div>
        <span className="far fa-lightbulb text-muted"></span>
        &nbsp; {props.headerText}
      </div>
    );
  }

  function fabtcTemplate(props) {
    return (
      <div>
        <span className="fab fa-btc text-muted"></span>
        &nbsp; {props.headerText}
      </div>
    );
  }

  const valueAccessDHM = (field, data) => {
    return ConvertMiniutDuration_calbyconfig(data[field]);
  };

  const HideValue = (field, data, column) => {
    return Returnhidevalue(data[field]);
  };

  const valueTemp_Ts_Date = (props) => {
    let day = props.ts_Date.slice(0, 5);
    let date = props.ts_Date.slice(5);
    return (
      <>
        <span className="text-muted text-smaller">{day}</span> {date}
      </>
    );
  };

  const valueTemp_task_timeoff = (props) => {
    let value = props.task_timeoff;

    if (props.type_tasktimeoff === "T") {
      return (
        <>
          {value} {Return_i_note(props.note)}
        </>
      );
    } else {
      return (
        <>
          <span className="text-italic text-muted">Time Off:</span>
          {value} {Return_i_note(props.note)}
        </>
      );
    }
  };

  function Return_i_note(note) {
    if (note !== "") {
      return (
        <>
          <HtmlTooltip
            title={
              <>
                <div>note : {note}</div>
              </>
            }
          >
            <i className="fas fa-info-circle tip text-muted"></i>
          </HtmlTooltip>
        </>
      );
    } else {
      return <></>;
    }
  }

  const valueTemp_staff_fullname = (props) => {
    return (
      <>
        <div className="staffs-list">
          {props.staff_fullname}{" "}
          <HtmlTooltip
            title={
              <>
                <div>
                  Department:{props.department_name},Position:
                  {props.position_name}
                </div>
              </>
            }
          >
            <i className="fas fa-info-circle tip text-muted"></i>
          </HtmlTooltip>
          {/* <i className="fas fa-info-circle tip text-muted" data-toggle="tooltip" 
        title={"Department:" + props.department_name +  ",Position:" + props.position_name }>
        </i> */}
        </div>
      </>
    );
  };

  const valueTemp_ts_status = (props) => {
    const valueStatusReturn = {
      0: (
        <span
          className={ConfigETC.TS_InProgress_Class + " text-smaller"}
          title={ConfigETC.TS_InProgress_Text}
        >
          {ConfigETC.TS_InProgress_Text}
        </span>
      ),
      10: (
        <span
          className={ConfigETC.TS_ToReview_Class + " text-smaller"}
          title={ConfigETC.TS_ToReview_Text}
        >
          {ConfigETC.TS_ToReview_Text}
        </span>
      ),
      11: (
        <span
          className={ConfigETC.TS_ToApprove_Class + " text-smaller"}
          title={ConfigETC.TS_ToApprove_Text}
        >
          {ConfigETC.TS_ToApprove_Text}
        </span>
      ),
      20: (
        <span
          className={ConfigETC.TS_Approved_Class + " text-smaller"}
          title={ConfigETC.TS_Approved_Text}
        >
          {ConfigETC.TS_Approved_Text}
        </span>
      ),
      30: (
        <span
          className={ConfigETC.TS_Clearing_Class + " text-smaller"}
          title={ConfigETC.TS_Clearing_Text}
        >
          {ConfigETC.TS_Clearing_Text}
        </span>
      ),
      12: (
        <span
          className={ConfigETC.TS_Reject_Class + " text-smaller"}
          title={ConfigETC.TS_Reject_Text}
        >
          {ConfigETC.TS_Reject_Text}
        </span>
      ),
    };

    const valueRejectReturn = {
      1: (
        <HtmlTooltip
          title={
            <>
              <div>Reject Desc : {props.reject_desc} | By : {props.reject_by}
              </div>
            </>
          }
        >
          <i className="fas fa-info-circle tip text-muted"></i>
        </HtmlTooltip>
      ),
    };

    return (
      <>
        {valueStatusReturn[props.ts_status]}{" "}
        {valueRejectReturn[props.is_reject]}
      </>
    );
  };

  //#endregion

  return (
    <>
      <Helmet>
        <title>Transaction report </title>
      </Helmet>

      {isLoadProgress && (
        <div
          id="divLoadingProgress"
          name="divLoadingProgress"
          align="center"
          className="divWaiting"
        >
          <img alt="progress" src="../dist/img/loading.gif" />
        </div>
      )}
      <div className="content-wrapper">
        <div className="content-header">
          <div className="row text-center ">
            <div className="col-md-10 offset-md-1 ">
              <div className="container-fluid">
                <h1 className=" display-5"> Transaction report </h1>
                <h6>Timesheet summary by transaction</h6>
              </div>
            </div>
          </div>
        </div>
        {/* /.content-header */}
        {/* Main content */}
        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-10 offset-md-1">
                <div className="row m-0">
                  
                  <div className="col-lg-4 col-12">
                    <div className="form-group m-0">
                      <label className="text-small p-0 m-0">Customer</label>
                      {isLoadedConfigData && (
                        <SelectCustomer
                        API_URL={configData.API_URL}
                        cus_status={"-1"}
                        selectismulti={false}
                        SelectTextDefault={ConfigETC.ddl_All}
                        resetSelect={iscntreset}
                        onChangevalue={onChangevaluesCustomer}
                        iscloseMenuOnSelect={true}
                      ></SelectCustomer>
                      )}
                    </div>
                    <input type="hidden" id="hd_cus_id_search" ></input>
                  </div>
                  <div className="col-lg-4 col-12">
                  <div className="form-group m-0">
                      <label className="text-small p-0 m-0">Project</label>
                      {isLoadedConfigData && (
                        <SelectProjectByCustomerBySearch
                          API_URL={configData.API_URL}
                          pro_status={"-1"}
                          selectismulti={true}
                          SelectTextDefault={ConfigETC.ddl_All}
                          resetSelect={iscntreset}
                          onChangevalue={onChangevaluesProject}
                          iscloseMenuOnSelect={false}

                          BindProjectBycusid={bindProjectBycusid}
                          hd_cus_id={"hd_cus_id_search"}
                          Bindendfunction={Bindendfunction_SP}
                        ></SelectProjectByCustomerBySearch>
                      )}
                    </div>
                  </div>
                  <div className="col-lg-4 col-12">
                  <div className="form-group m-0">
                      <label className="text-small p-0 m-0">Task</label>
                      {isLoadedConfigData && (
                        <SelectTaskMultiGroup
                          API_URL={configData.API_URL}
                          SelectTextDefault={ConfigETC.ddl_All}
                          resetSelect={iscntreset}
                          onChangevalue={onChangevaluesTask}
                          iscloseMenuOnSelect={false}
                        ></SelectTaskMultiGroup>
                      )}
                    </div>
                  </div>
                </div>
                <div className="row m-0">
                  <div className="col-lg-4 col-12">
                    <div className="form-group m-0">
                      <label className="text-small p-0 m-0">Time Off</label>
                      {isLoadedConfigData && (
                        <SelectTimeoff
                          API_URL={configData.API_URL}
                          timeoff_status={"-1"}
                          selectismulti={true}
                          SelectTextDefault={ConfigETC.ddl_All}
                          resetSelect={iscntreset}
                          onChangevalue={onChangevaluesTimeoff}
                          iscloseMenuOnSelect={false}
                        ></SelectTimeoff>
                      )}
                    </div>
                  </div>
                  <div className="col-lg-4 col-12">
                  <div className="form-group m-0">
                      <label className="text-small p-0 m-0">Staffs</label>
                      {isLoadedConfigData && (
                        <SelectStaff
                          API_URL={configData.API_URL}
                          staff_status={"-1"}
                          selectismulti={true}
                          SelectTextDefault={ConfigETC.ddl_All}
                          resetSelect={iscntreset}
                          onChangevalue={onChangevaluesStaff}
                          iscloseMenuOnSelect={false}
                        ></SelectStaff>
                      )}
                    </div>
                  </div>
                  <div className="col-lg-4 col-12">
                  <div className="form-group m-0">
                      <label className="text-small p-0 m-0">Date</label>
                      <DateRangePickerComponent
                      size="lg"
                      style={date_pickerStyle}
                        id="txt_SearchDate"
                        placeholder="Select a range"
                        format="dd/MM/yyyy"
                        presets={dataPresets}
                        strictMode={true}
                      />
                    </div>
                  </div>
                </div>
                <div className="row m-0">
                  
                  <div className="col-lg-4 col-sm-6 col-12">
                    <div className="form-group m-0">
                      <label className="text-small p-0 m-0">Status</label>
                      <Select
                        closeMenuOnSelect={false}
                        components={animatedComponents}
                        placeholder={ConfigETC.ddl_All}
                        isMulti
                        value={selectedSearchStatus}
                        options={Bind_Select_Status("Rp_Sum_pro")}
                        menuPortalTarget={document.body}
                        onChange={(e) => setSelectedSearchStatus(e)}
                        //styles={{
                          //  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                        //}}
                        styles={customStylesSelect}
                      />
                    </div>
                  </div>
                  <div className="col-lg-4 col-sm-6 col-12 text-center">
                    <div className="form-group m-0">
                      <label className="text-small p-0 m-0" />
                      <div className="card-tools">
                        <button
                          id="btn_Search"
                          type="button"
                          className="btn btn-primary "
                          onClick={onclickSearch}
                        >
                          <i className="fas fa-search" /> Search
                        </button>
                        {" "}
                        <button
                          type="button"
                          className="btn btn-default "
                          onClick={onclickReset}
                        >
                          <i className="fas fa-times" /> reset
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-4 col-sm-6 col-12">
                    
                  </div>
                </div>
              </div>
            </div>
            {/* /.col */}
            {isSearch && (
              <>
                <div className="row mt-3">
                  <div className="col-md-12">
                    <div className="card  card-outline shadow">
                      <div className="card-body table-responsive p-0">


                        <GridComponent
                          id="dg_report"
                          dataSource={listReport}
                          allowPaging={true}
                          allowSorting={true}
                          allowResizing={true}
                          allowReordering={true}
                          pageSettings={{
                            pageCount: ConfigETC.pageCount,
                            pageSize: ConfigETC.rowsPerPage,
                          }}
                          ref={(grid) => (gridInstance = grid)}
                          toolbar={datagridtoolbarOptions(listReport)}
                          allowExcelExport={true}
                          allowPdfExport={true}
                          allowGrouping={false}
                          toolbarClick={toolbarClick.bind(this)}
                          //className="custom-grid-Report_sumByTransaction"
                          beforePrint={beforePrint.bind(this)}
                          hierarchyPrintMode="All"
                        >
                          <ColumnsDirective>
                          
                            <ColumnDirective
                              field="rowindex"
                              headerText="#"
                              width="3%"
                              textAlign="left"
                              allowSorting={false}
                            ></ColumnDirective>

                            <ColumnDirective
                              field="ts_Date"
                              headerText="Date"
                              width="13%"
                              template={valueTemp_Ts_Date}
                              allowSorting={false}
                            ></ColumnDirective>

                            <ColumnDirective
                              field="project_name"
                              headerText="Project"
                              width="15%"
                              allowSorting={true}
                            ></ColumnDirective>

                            <ColumnDirective
                              field="task_timeoff_excel"
                              headerText="Tasks/TimeOff"
                              width="15%"
                              template={valueTemp_task_timeoff}
                              allowSorting={true}
                            ></ColumnDirective>

                            <ColumnDirective
                              field="staff_fullname_excel"
                              headerText="Staffs"
                              width="15%"
                              allowSorting={true}
                              template={valueTemp_staff_fullname}
                            ></ColumnDirective>

                            <ColumnDirective
                              field="wt"
                              headerText="WT"
                              width="7%"
                              allowSorting={true}
                              valueAccessor={valueAccessDHM}
                              headerTemplate={faclockTemplate}
                            ></ColumnDirective>

                            {isSVOT &&
                              <ColumnDirective
                                field="ot"
                                headerText="OT"
                                width="7%"
                                allowSorting={true}
                                valueAccessor={valueAccessDHM}
                                headerTemplate={falightTemplate}
                              ></ColumnDirective>
                            }

                            <ColumnDirective
                              field="extra"
                              headerText="Per diem allowance"
                              width="10%"
                              allowSorting={true}
                              format="N2"
                              headerTemplate={fabtcTemplate}
                              valueAccessor={HideValue}
                            ></ColumnDirective>
                            <ColumnDirective
                              field="extra_day"
                              headerText="Per diem allowance(day)"
                              width="15%"
                              allowSorting={true}
                              format="N2"
                              valueAccessor={HideValue}
                            ></ColumnDirective>



                            <ColumnDirective
                              field="travel"
                              headerText="Travel"
                              width="7%"
                              allowSorting={true}
                              format="N2"
                              headerTemplate={fabtcTemplate}
                              valueAccessor={HideValue}
                            ></ColumnDirective>
                            <ColumnDirective
                              field="travel_distance"
                              headerText="Travel (distance)"
                              width="7%"
                              allowSorting={true}
                              format="N2"
                              valueAccessor={HideValue}
                            ></ColumnDirective>

                            <ColumnDirective
                              field="other"
                              headerText="Other"
                              width="7%"
                              allowSorting={true}
                              format="N2"
                              headerTemplate={fabtcTemplate}
                              valueAccessor={HideValue}
                            ></ColumnDirective>

                            <ColumnDirective
                              field="ts_status_excel"
                              headerText="Status"
                              width="7%"
                              allowSorting={true}
                              template={valueTemp_ts_status}
                            ></ColumnDirective>
                          </ColumnsDirective>
                          <Inject
                            services={[
                              Page,
                              Sort,
                              Toolbar,
                              ExcelExport,
                              PdfExport,
                              Group,
                              Resize,
                              Reorder,
                            ]}
                          />
                        </GridComponent>
                      
                        <div style={{display : "none"}} >

                          <GridComponent
                            id="dg_reportPrint"
                            dataSource={listReport}
                            allowPaging={true}
                            allowSorting={true}
                            allowResizing={true}
                            allowReordering={true}
                            pageSettings={{
                              pageCount: ConfigETC.pageCount,
                              pageSize: ConfigETC.rowsPerPage,
                            }}
                            ref={(grid) => (gridInstancePrint = grid)}
                            toolbar={datagridtoolbarOptions(listReport)}
                            allowExcelExport={true}
                            allowPdfExport={true}
                            allowGrouping={false}
                            toolbarClick={toolbarClick.bind(this)}
                            //className="custom-grid-Report_sumByTransaction"
                            beforePrint={beforePrint.bind(this)}
                            hierarchyPrintMode="All"
                          >
                            <ColumnsDirective>

                              <ColumnDirective
                                field="rowindex"
                                headerText="#"
                                width="3%"
                                textAlign="left"
                                allowSorting={false}
                              ></ColumnDirective>

                              <ColumnDirective
                                field="ts_Date"
                                headerText="Date"
                                width="10%"
                                allowSorting={false}
                              ></ColumnDirective>

                              <ColumnDirective
                                field="project_name"
                                headerText="Project"
                                width="15%"
                                allowSorting={true}
                              ></ColumnDirective>

                              <ColumnDirective
                                field="task_timeoff_excel"
                                headerText="Tasks/TimeOff"
                                width="15%"
                                allowSorting={true}
                              ></ColumnDirective>

                              <ColumnDirective
                                field="staff_fullname_excel"
                                headerText="Staffs"
                                width="15%"
                                allowSorting={true}
                              ></ColumnDirective>

                              <ColumnDirective
                                field="wt"
                                headerText="WT"
                                width="7%"
                                allowSorting={true}
                                valueAccessor={valueAccessDHM}
                                headerTemplate={faclockTemplate}
                              ></ColumnDirective>

                              {isSVOT &&
                                <ColumnDirective
                                  field="ot"
                                  headerText="OT"
                                  width="7%"
                                  allowSorting={true}
                                  valueAccessor={valueAccessDHM}
                                  headerTemplate={falightTemplate}
                                ></ColumnDirective>
                              }

                              <ColumnDirective
                                field="extra"
                                headerText="PER DIEM ALLOWANCES"
                                width="13%"
                                allowSorting={true}
                                format="N2"
                                headerTemplate={fabtcTemplate}
                                valueAccessor={HideValue}
                              ></ColumnDirective>
                              <ColumnDirective
                                field="extra_day"
                                headerText="PER DIEM ALLOWANCES (day)"
                                width="17%"
                                allowSorting={true}
                                format="N2"
                                valueAccessor={HideValue}
                              ></ColumnDirective>


                              <ColumnDirective
                                field="travel"
                                headerText="Travel"
                                width="7%"
                                allowSorting={true}
                                format="N2"
                                headerTemplate={fabtcTemplate}
                                valueAccessor={HideValue}
                              ></ColumnDirective>
                              <ColumnDirective
                                field="travel_distance"
                                headerText="Travel (distance)"
                                width="7%"
                                allowSorting={true}
                                format="N2"
                                valueAccessor={HideValue}
                              ></ColumnDirective>



                              <ColumnDirective
                                field="other"
                                headerText="Other"
                                width="7%"
                                allowSorting={true}
                                format="N2"
                                headerTemplate={fabtcTemplate}
                                valueAccessor={HideValue}
                              ></ColumnDirective>

                              <ColumnDirective
                                field="ts_status_excel"
                                headerText="Status"
                                width="7%"
                                allowSorting={true}
                              ></ColumnDirective>

                            </ColumnsDirective>
                            <Inject
                              services={[
                                Page,
                                Sort,
                                Toolbar,
                                ExcelExport,
                                PdfExport,
                                Group,
                                Resize,
                                Reorder,
                              ]}
                            />
                          </GridComponent>
                      
                        </div>
                      
                      
                      </div>
                    </div>{" "}
                    {/* /.card */}
                  </div>
                  {/* /.row (main row) */}
                </div>
              </>
            )}

            {/* /.container-fluid */}
          </div>
        </section>
        {/* /.content */}
      </div>
    </>
  );
}

export default Report_sumByTransaction;
